import * as angular from "angular";
import * as _ from "lodash";
import {PredefinedSkillType} from "../../skills/types/predefined-skill.type";

export class LabelsDialogService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  // ******************************
  // External methods
  // ******************************

  create(currentLabels, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-label-dialog.html').default,
      controller: function ($scope) {

        const currentLabelNames = _.map(currentLabels, (l) => {
          return l.name.toLowerCase();
        });

        $scope.PredefinedSkillTypesList = Object.values(PredefinedSkillType);
        $scope.header = 'Create New Label';
        $scope.action = 'Submit';
        $scope.label = {
          name: undefined,
          color: '#278BFF',
          active: true,
          requiredSkills: undefined
        };
        $scope.cancel = self.$mdDialog.cancel;

        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onNameChange = (name) => {
          name = name.toLowerCase();
          $scope.createLabelForm.name.$setValidity('exists', !_.includes(currentLabelNames, name));
        }

        $scope.onColorChange = (color) => {
          $scope.label.color = color;
        }

        $scope.onSkillsChange = (ids) => {
          $scope.label.requiredSkills = ids;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide($scope.label);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  edit(label, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-label-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Edit Label';
        $scope.action = 'Update';
        $scope.disableName = true;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.label = angular.copy(label);

        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onColorChange = (color) => {
          $scope.label.color = color;
        }

        $scope.onSkillsChange = (ids) => {
          $scope.label.requiredSkills = ids;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide($scope.label);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.labels')
  .service('labelsDialogService', LabelsDialogService);
